import Vue from 'vue';
import * as types from "./types";

const mutations = {
    [types.LOADING_CUSTOMFIELDS](state, {section, value}) {
        if(!state.loading[section]){
            Vue.set(state.loading, section, value);
        }else{
            state.loading[section] = value;
        }
    },
    [types.GET_CUSTOMFIELD_LIST](state, {section, fields}) {
        if(!state.customFields[section]){
            Vue.set(state.customFields, section, fields.customFields);
        }else{
            state.customFields[section] = fields.customFields;
        }
    },
    [types.REMOVE_CUSTOMFIELD](state, {section, id}) {
        if(!state.customFields[section]){
            Vue.set(state.customFields, section, []);
        }else{
            state.customFields[section] = state.customFields[section].filter(x => x.id != id);
        }
    },
    [types.UPSERT_CUSTOMFIELD](state, {section, fields}) {        
        if(!state.customFields[section]){
            Vue.set(state.customFields, section, fields);
        }else{
            state.customFields[section].unshift(fields);
        }
    },
};

export default mutations;